var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ranking",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.071,
    height: 28.472,
    viewBox: "0 0 32.071 28.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M23.207,34.064a1.078,1.078,0,0,1-.52-.134L8.552,26.157H2V24H8.829a1.078,1.078,0,0,1,.52.134L23.112,31.7,32.4,24.647l1.3,1.715-9.844,7.482a1.078,1.078,0,0,1-.652.22Z",
    transform: "translate(-1.631 -9.555)",
    fill: "#ff7163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M3.416,32.379l-1.929-.965L12.034,10.321a1.078,1.078,0,0,1,1.446-.482,1.021,1.021,0,0,1,.144.087l9.187,6.562L31.8,3.907l1.756,1.254L23.941,18.619a1.078,1.078,0,0,1-1.5.251h0L13.4,12.414Z",
    transform: "translate(-1.487 -3.907)",
    fill: "#072ff7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.2ebcc54f68a6efc258a0d72f2627abf4.svg";
export { ForwardRef as ReactComponent };